// Environment configuration
const isDevelopment = process.env.NODE_ENV === 'development';

export const config = {
  API_BASE_URL: isDevelopment ? 'http://localhost:3001/api' : 'https://pm2api.kuark.xyz/api',
  SOCKET_URL: isDevelopment ? 'http://localhost:3001' : 'https://pm2api.kuark.xyz',
  FRONTEND_URL: isDevelopment ? 'http://localhost:3000' : 'https://pm2.kuark.xyz'
};
